import styles from './Success.module.css';
import { useSuccess } from './Success.hooks';

import { Loading } from '../../../../components/loading/Loading';
import { Link } from 'react-router-dom';

export const Success = () => {
	const { isLoading, error, isSubscribed } = useSuccess();
	if (error) {
		return <div className={styles['error']}>{error.message}</div>;
	}
	if (isLoading) {
		return (
			<div className={styles['loading']}>
				<Loading />
			</div>
		);
	}

	if (!isSubscribed) {
		return <SubscriptionRequired />;
	}

	return <SuccessAuthenticated />;
};

function SubscriptionRequired() {
	return (
		<div className={styles['subscription-required']}>
			<h1>
				You are authenticated,
				<br /> but lack a valid subscription
			</h1>
			<Link to={'/subscriptions'}>Buy Subscription</Link>
			<p>Or</p>
			<Link to={'/'}>Go Home</Link>
		</div>
	);
}

function SuccessAuthenticated() {
	return (
		<div className={styles['subscription']}>
			<section>
				<h1>Payment Successful</h1>
				<h2>Thanks for purchasing a subscription</h2>
				<Link to={'/'}>Read Now</Link>
			</section>
		</div>
	);
}
